/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/common/js/HM_preload.js
*    TO   --> ./legacy-web/src/main/assets/js/common/hm-preload.js
**/

if(window.event + '' == 'undefined') {
    event = null;
}

function HM_f_PopUp() {return false;};
function HM_f_PopDown() {return false;};
var popUp = HM_f_PopUp;
var popDown = HM_f_PopDown;

//This array will hold the newly created IMAGE objects
var preloadArray = new Array();
var menuItem = 'initItem';
var menuNum = 0;

var myimages = [];

function preloadimages() {
    for(var i = 0; i < preloadimages.arguments.length; i++) {
        myimages[i] = new Image();
        myimages[i].src = preloadimages.arguments[i];

    }
}

//added 11-15 by Lisa
function contactAA(pageName) {

    window.open(pageName, 'ContactAA', 'scrollbars=yes,menubar=no,resizable=yes,width=680,height=430,top=100,left=100');
}

function printPage(pageName) {
    window.open(pageName, 'Print',
        'toolbar=no,status=no,width=680,height=430,scrollbars=yes,directories=no,location=no,resizable=yes,menubar=yes,screenX=100,screenY=100,top=10,left=50');
}

function printViewMiles(pageName) {
    window.open(pageName, 'Print', 'scrollbars=yes,menubar=yes,resizable=yes,width=720,height=430,top=100,left=100');
}

function rollover(menuID, num) {
    var imageSwitch = eval('document.' + menuID);
    imageSwitch.src = myimages[num].src;
}

//sets the base properties for the menu items
var HM_PG_MenuWidth = 130;
var HM_PG_FontFamily = 'Arial,sans-serif';
var HM_PG_FontSize;
if(navigator.appVersion.indexOf('Mac') != -1) {
    HM_PG_FontSize = 10;
}
else{
    HM_PG_FontSize = 8;
}

var HM_PG_FontBold = 0;
var HM_PG_FontItalic = 0;
var HM_PG_FontColor = '#000000';
var HM_PG_FontColorOver = '#000000';
var HM_PG_BGColor = '#D9E2F4';
var HM_PG_BGColorOver = '#FFFFFF';
var HM_PG_ItemPadding = 1;

var HM_PG_BorderWidth = 1;
var HM_PG_BorderColor = 'black';
var HM_PG_BorderStyle = 'solid';
var HM_PG_SeparatorSize = 1;
var HM_PG_SeparatorColor = '#000066';
var HM_PG_ImageSrc = '/content/images/nav/more.gif';
var HM_PG_ImageSrcLeft = '/content/images/nav/more.gif';

var HM_PG_ImageSize = 8;
var HM_PG_ImageHorizSpace = 1;
var HM_PG_ImageVertSpace = 2;

var HM_PG_KeepHilite = true;
var HM_PG_ClickStart = 0;
var HM_PG_ClickKill = false;
var HM_PG_ChildOverlap = 1;
var HM_PG_ChildOffset = -1;
var HM_PG_ChildPerCentOver = null;
var HM_PG_TopSecondsVisible = .1;
var HM_PG_StatusDisplayBuild = 0;
var HM_PG_StatusDisplayLink = 1;
var HM_PG_UponDisplay = null;
var HM_PG_UponHide = null;
var HM_PG_RightToLeft = false;

var HM_PG_CreateTopOnly = 1;
var HM_PG_ShowLinkCursor = 1;
var HM_PG_NSFontOver = true;

// Begin - TS #15601
function viewAvailableSeats(viewSeatsURL, solutionCount) {
    for(var j = 1; j <= solutionCount; j++) {
        var selected = 0;
        for(var i = 0; i < document.getElementsByName("flightSolution" + j).length; i++) {
            var radio = document.getElementsByName('flightSolution' + j)[i];
            if(radio.checked) {
                selected = i + 1;
                break;
            }
        }
        if(selected !== 0) {
            viewSeatsURL += '&radioSelected' + j + '=' + selected;
        }
    }
    //window.location.href = "" + viewSeatsURL;
    openViewAvailableSeats(viewSeatsURL);

    return viewSeatsURL;
}
// End - TS #15601

//Begin - M3/MCE
var winViewSeats;
function openViewAvailableSeats(_url) {
    try { winViewSeats.windowObject.busyStart(); }catch (e) {}
    winViewSeats = new aaGenericPopup(_url, 'aaViewSeats', 'CUSTOM', 900, 650);
    winViewSeats.open();

    return false;
}
// End - M3/MCE
